import { render, staticRenderFns } from "./IcoHandAssignedDoc.vue?vue&type=template&id=1d97f22b"
import script from "./IcoHandAssignedDoc.vue?vue&type=script&lang=js"
export * from "./IcoHandAssignedDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports